import React from "react";

export default function Coagulation() {
  return <div>Coassgulation</div>;
}
